// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 686) return "static/chunks/686-70d2754d32ad738a.js";
	if (chunkId === 456) return "static/chunks/456-bf33ee67e50a9e37.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"02e085d68ab7929c","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"40c84616b7f2d5ec","367":"0d39828ba3104fe4","639":"6f30bd92b2c07e9c","748":"6dc7943fae9a4c99"}[chunkId] + ".js";
};